import React, { useEffect, useState, useRef } from 'react';
import RequestDetailsCard from '../RequestsOverView/RequestDetailsCard';
import LoaderComponent from '../../ReusableComponents/LoaderComponent';
import InfiniteScroll from 'react-infinite-scroll-component';
import { QUEUE_ORDER_STATUS } from '../../appConstants';
import reloadLogo from '../../assets/up-arrow.png';
import Tippy from '@tippyjs/react';

export default function RecentRequestSection({
    requests,
    filters,
    hasMore,
    selectedRequest,
    handleRequestClick,
    isLoading,
    previousRequestLoading,
    fetchMoreRequests,
    fetchPreviousRequests,
    currentPageNumber
}) {
    const [page, setPage] = useState(undefined);
    const [isAtTop, setIsAtTop] = useState(true);
    const scrollableDivRef = useRef(null);

    useEffect(() => {
        console.log(currentPageNumber)
        setPage(( currentPageNumber || filters?.pageNumber));
    }, [currentPageNumber]);

    useEffect(() => {
        console.log(selectedRequest);
        if (requests.length > 0 && !selectedRequest) {
            handleRequestClick(requests[0]);
        }
    }, [requests, selectedRequest, handleRequestClick]);

    useEffect(() => {
        const handleScroll = () => {
            if (scrollableDivRef.current) {
                setIsAtTop(scrollableDivRef.current.scrollTop === 0);
            }
        };

        const scrollableDiv = scrollableDivRef.current;
        if (scrollableDiv) {
            scrollableDiv.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (scrollableDiv) {
                scrollableDiv.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);
    return (
        <div className='w-[100%] border border-r-[#D9D9D9] rounded-tl-[15px] rounded-bl-[15px] h-[100%] flex flex-col relative'>
            <p className='px-8 pt-6 pb-4 text-[20px] font-[700]'>Lead Orders</p>
            <div
                className='h-[90%] max-h-[90%] overflow-y-scroll px-0'
                id="scrollableDiv"
                ref={scrollableDivRef}
            >
                {previousRequestLoading && (
                    <div className="z-10 w-full mt-2 flex justify-center absolute">
                        <LoaderComponent width={"6%"} height={"6%"} />
                    </div>
                )}

                {page > 1 && isAtTop && (
                    <div className="absolute z-10 mt-2 w-full flex justify-center cursor-pointer">
                        {!previousRequestLoading && (
                            <img
                                src={reloadLogo}
                                width={30}
                                height={10}
                                alt='reload-img'
                                onClick={() => {
                                    fetchPreviousRequests(page - 1);
                                    setPage(page - 1);
                                }}
                                disabled={isLoading}
                            />
                        )}
                    </div>
                )}

                <InfiniteScroll
                    dataLength={requests.length}
                    next={() => {
                        const nextPageNumber = filters?.pageNumber + 1;
                        fetchMoreRequests(nextPageNumber);
                    }}
                    endMessage={
                        <p className='font-manrope font-[700] text-[15px] mt-2 text-center'>
                            All Requests are fetched!
                        </p>
                    }
                    hasMore={hasMore}
                    loader={isLoading && <LoaderComponent width={"10%"} height={"25%"} />}
                    scrollableTarget="scrollableDiv"
                >
                    {requests && requests.length > 0 ?
                        requests.map((req) => {
                        return (
                            <RequestDetailsCard
                                key={req.id}
                                request={{...req}}
                                selectedRequest={selectedRequest}
                                handleClick={(request) => handleRequestClick(request)}
                            />
                        )
                        })
                        :
                        (
                            <div className="flex justify-center items-center h-[100%] mt-80">
                                <div className="font-manrope text-[#3B3B3B] text-lg font-semibold">
                                    No requests.
                                </div>
                            </div>
                        )}
                </InfiniteScroll>
            </div>
        </div>
    );
}
